import { useQuery } from "react-query";
import { AdminJobDetailResponse } from "../../../../models/Job";
import { KandidatResponse } from "../../../../models/Kandidat";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import { fetchAllKandidatKey } from "./useFetchAllKandidat";
import ApiClient from "../../../apiClient";

export async function fetchAllInterview(): Promise<KandidatResponse[]> {
  const res = await ApiClient.get(`/AllInterview`);
  return res.data;
}

export default function useFetchAllInterview() {
  return useQuery([fetchAllKandidatKey], queryWrapper(fetchAllInterview));
}
